export default __webpack_public_path__ + "static/media/icon.cecb9622.svg";